
export class FilterPoData {
  public  company_code?: string;
  public  plant?: string;
  public doc_type?: string;
  public doc_cat?: string;
  public poagreement_no?: string;
  public  vendor_code?: string;
  public  status?: string;
  public  document_date?: Date; 
  public valid_from?: Date; 
  public valid_to?: Date; 
  [key: string]: string | Date | undefined; 
}